/**
 * PageLoader — fallback Suspense pour le lazy-loading des pages.
 * Centré plein écran, spinner Samsung Blue animé.
 */
import { useT } from '@/lib/i18n';
export function PageLoader() {
  const t = useT();
  return (
    <div className="flex h-screen w-full items-center justify-center bg-surface-dark">
      <div className="flex flex-col items-center gap-4">
        {/* ★2 `#839` — l'aria disait « Chargement... » en points ASCII quand le
            texte, deux lignes plus bas, disait « Chargement… ». UNE SEULE FORME. */}
        <div
          className="h-10 w-10 animate-spin rounded-full border-4 border-brand-samsung-500 border-t-transparent"
          role="status"
          aria-label={t('commun.chargement')}
        />
        <span className="text-sm text-muted-foreground">{t('commun.chargement')}</span>
      </div>
    </div>
  );
}
